var ApiStage;
(function (ApiStage) {
    ApiStage["Beta"] = "beta";
    ApiStage["Local"] = "local";
    ApiStage["Prod"] = "prod";
})(ApiStage || (ApiStage = {}));
export default ApiStage;
//# sourceMappingURL=ApiStage.js.map